<template>
  <!-- 用户管理详情 -->
  <div class="container">
    <div v-if="!$deviceState.isMobile">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/userManagement' }"
          >用户管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          >用户管理详情：{{ $route.query.userName }}</el-breadcrumb-item
        >
      </el-breadcrumb>

      <el-card class="box-card set-scroll">
        <el-table
          :data="tableData"
          style="width: 100%"
          @row-click="clickControl"
        >
          <!-- <el-table-column type="index" width="60"> </el-table-column> -->
          <el-table-column label="序号" min-width="30">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (pageData.pageNum - 1) * pageData.pageSize
              }}
            </template>
          </el-table-column>

          <!-- <el-table-column prop="date" label="日期" width="160">
        </el-table-column> -->
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column
            prop="HVAC_EnergyConsumption_Annual"
            label="项目暖通系统年用电量"
          >
          </el-table-column>
          <el-table-column prop="HVAC_AveragePSR_Annual" label="年均节能率">
          </el-table-column>

          <el-table-column prop="HVAC_PowerSavings_Annual" label="年均节电量">
          </el-table-column>

          <el-table-column prop="HVAC_PowerSavings_Monthly" label="月均节电量">
          </el-table-column>

          <el-table-column prop="Power_UnitPrice" label="电费单价">
          </el-table-column>

          <el-table-column prop="HVAC_Savings_Total" label="项目年均总节电费">
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.pageNum"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </el-card>
    </div>
    <userManagementDetails v-else></userManagementDetails>
  </div>
</template>

<script>
import userManagementDetails from '@/views/mobile/userManagementDetails.vue'
import { getOffer } from '@/api/home/index'
export default {
  components: { userManagementDetails },
  data () {
    return {
      tableData: [],
      totalPage: 0,
      pageData: {
        // uerName: JSON.parse(localStorage.getItem('userInfo')).userName,
        userName: this.$route.query.userName,
        pageSize: 12,
        pageNum: 1
      }
    }
  },
  mounted () {
    this.initData(this.pageData)
  },
  methods: {
    async initData (page) {
      try {
        const res = await getOffer(page)
        this.tableData = res.data.data
        this.totalPage = res.data.total
        console.log('列表', res.data.data)
      } catch (error) {}
    },

    //
    clickControl (row) {
      console.log('点击项id', row.id)
      this.$router.push({
        path: 'budgetSheet',
        query: {
          id: row.id,
          title: 1,
          userName: this.$route.query.userName,
          permission: true
        }
      })
    },
    handleSizeChange () {},
    handleCurrentChange (page) {
      this.pageData.pageNum = page
      this.initData(this.pageData)
      console.log('选择页码', page)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: calc(100% - 70px);
  padding: 10px 16px;
  // height: calc(100vh - 90px);
  // margin: 20px;
  // background-color: #fff;

  .el-breadcrumb {
    margin: 20px;
  }
  .el-card {
    height: calc(100vh - 134px);
    p {
      margin-top: 300px;
      text-align: center;
      font-size: 26px;
      color: #f56c6c;
      font-weight: 600;
      letter-spacing: 0.5em;
    }
  }
  .el-pagination {
    margin-top: 20px;
  }
}
</style>
